module.exports = __webpack_public_path__ + "img/code4.58f67c8d.png";